"use client";

// Extra tool-view registry seam (plan 024, gap-audit T16). The block's
// `ToolPart` consults `useToolRegistry()` for views registered via
// `defineClientTool`; hosts that own server-side tool UIs (the flagship's
// built-in registry: MS Graph, GitHub, office statuses, …) inject them here
// and they merge under the same lookup — the block never learns what the
// tools are.
import { c as _c } from "react/compiler-runtime";
import type { ToolUIRegistry } from "@bg-bgi/magnus-sdk/react";
import { createContext, type ReactNode, useContext } from "react";
const ToolViewsContext = createContext<ToolUIRegistry | undefined>(undefined);

/** Provides host-registered tool views to every `ToolPart` below. */
export function ToolViewsProvider(t0) {
  const $ = _c(3);
  const {
    children,
    toolViews
  } = t0;
  let t1;
  if ($[0] !== children || $[1] !== toolViews) {
    t1 = <ToolViewsContext.Provider value={toolViews}>{children}</ToolViewsContext.Provider>;
    $[0] = children;
    $[1] = toolViews;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}

/** The host's extra tool views, or `undefined` (client tools only). */
export function useExtraToolViews() {
  return useContext(ToolViewsContext);
}